import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./style.css";
import "./styles/fonts.css";
import "../src/styles/global.css";
import { CartProvider } from "./context/CartContext";
import { PrescriptionCartProvider } from "./context/pharmacy/PrescriptionCartContext";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(



  <CartProvider>
    <PrescriptionCartProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PrescriptionCartProvider>
  </CartProvider>,
);
